var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Row',{staticClass:"flex-end--center footer-container py-1"},[_c('a',{attrs:{"href":_setup.PLY_APP_URL,"target":"_blank"}},[_c('AppIcon',{attrs:{"name":"powered-by-flow-run"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }